import { IANAZone } from 'luxon'
import z from 'zod'

/**
 * IsoInstant:  "2026-01-01T00:00:00Z"  an exact moment, always UTC, from/to the API
 * IsoDate:     "2026-01-01"            a calendar date with no zone (schedule week, form date)
 * LocalTime:   "22:00"                 a wall-clock time with no zone or date (form time)
 */

export const IsoInstant = z.iso.datetime({ precision: 0 }).brand<'IsoInstant'>()

export const IsoDate = z.iso.date().brand<'IsoDate'>()

export const LocalTime = z.iso.time({ precision: -1 }).brand<'LocalTime'>()

export const IanaZone = z
  .string()
  .refine((s) => IANAZone.isValidZone(s))
  .brand<'IanaZone'>()

export type IsoInstant = z.infer<typeof IsoInstant>
export type IsoDate = z.infer<typeof IsoDate>
export type LocalTime = z.infer<typeof LocalTime>
export type IanaZone = z.infer<typeof IanaZone>
